<template>
  <section class="app-main">
    <el-main class="message-alert">
      <slot name="notification" />
      <MessageAlertDefault />
      <MessageAlertPayPal />
    </el-main>
    <router-view v-slot="{ Component }">
      <transition name="fade-transform" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <AppFooter />
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { useAppStore } from '@/store/modules/app'
import AppFooter from './AppFooter/index.vue'
import MessageAlertDefault from './MessageAlert/Default.vue'
import MessageAlertPayPal from './MessageAlert/PayPal.vue'

export default defineComponent({
  name: 'AppMain',
  components: {
    MessageAlertDefault,
    MessageAlertPayPal,
    AppFooter
  },
  setup() {
    const appStore = useAppStore()
    onMounted(async () => {
      if (/product_tour_id/.test(window.location.search)) {
        appStore.OpenSideBar(false)
      }
    })
  }
})
</script>

<style lang="scss" scoped>
.app-main {
  overflow: hidden;
}
.el-main:first-child {
  padding-bottom: 0;
  padding-top: 0;
}
.el-alert {
  margin: 5px 0 0;
}
.el-alert:first-child {
  margin: 0;
}
</style>
